// extracted by mini-css-extract-plugin
export default {"block":"forgot-password_block__lVlGi","title":"forgot-password_title__iKUt6","form":"forgot-password_form__8jHLk","link":"forgot-password_link__4o5Ic"};